export default {
  methods: {
    updateSeriesActivity() {
      console.log('updateSeriesActivity');
    },
    removeArrayEleOperation(index) {
      this.$data.arrayEleOperation.splice(index, 1);
    },
    addArrayEleOperation() {
      this.clearSequence();

      this.$data.bShowSequenceExercise = true;
      this.$data.bNewSequence = true;
      this.$data.idEleOperationEdit = this.$data.arrayEleOperation.length;
      this.$data.arrayEleOperation.push({
        POSICION: this.$data.arrayEleOperation.length + 1,
        ELEMENTSEQUENCE: [], // Store here the series elements
      });

      // Add least three items
      this.addArraySequence();
      this.addArraySequence();
      this.addArraySequence();
    },
    /**
    * @description Sequences
    */
    removeArraySequence() {
      this.$data.arrayElementSequence.pop();
    },
    addArraySequence() {
      this.$data.arrayElementSequence.push({
        POSICION: this.$data.arrayElementSequence.length + 1,
        VALOR: null,
        VISIBLE: true,
        INCOGNITA: false,
      });
    },
    clearSequence() {
      this.$data.idEleOperationEdit = -1;
      this.$data.bShowSequenceExercise = false;
      // Clear element with empty sequence
      if (this.$data.bNewSequence) {
        this.removeArrayEleOperation(this.$data.idEleOperationEdit);
        this.$data.bNewSequence = false;
      }
      this.$data.arrayElementSequence = [];
    },
    editSequence(index) {
      // Recorrer el arrayelementSequence y armar un nuevo array formateando
      let pos = 1;
      const sequence = [];
      this.$data.arrayEleOperation[index].ELEMENTSEQUENCE.forEach((element) => {
        sequence.push({
          POSICION: pos,
          VALOR: element.VALOR,
          INCOGNITA: element.INCOGNITA,
          VISIBLE: element.VISIBLE,
        });
        pos += 1;
      });

      // Cpy on the temporal array to edit
      this.$data.idEleOperationEdit = index;
      this.$data.arrayElementSequence = sequence;
      this.$data.bShowSequenceExercise = true;
      this.$data.bNewSequence = false;
    },
    saveSequence(index) {
      this.$refs.formValidation.validate().then((success) => {
        if (!success) {
          return;
        }

        // Recorrer el arrayelementSequence y armar un nuevo array formateando
        let pos = 1;
        const sequence = [];
        this.$data.arrayElementSequence.forEach((element) => {
          sequence.push({
            POSICION: pos,
            VALOR: element.VALOR,
            INCOGNITA: element.INCOGNITA == null ? false : element.INCOGNITA,
            VISIBLE: element.VISIBLE == null ? false : element.VISIBLE,
          });
          pos += 1;
        });

        // Save on the current editing eleOperation
        this.$data.arrayEleOperation[index].ELEMENTSEQUENCE = sequence;
        this.$data.bShowSequenceExercise = false;
        this.$data.bNewSequence = false;
      });
    },
    /**
    * @method saveStorage
    * @description Guarda los datos del formulario
    */
    saveStorage() {
      this.$refs.exercise_child.$refs.formValidation.validate().then((exerciseOK) => {
        if (!exerciseOK) {
          return;
        }

        this.$refs.formValidation.validate().then((success) => {
          if (!success) {
            return;
          }

          this.$nextTick(() => {
            this.$refs.exercise_child.active();
          });

          const { objexercise } = this.$refs.exercise_child;
          const copyarrayEleOperation = JSON.parse(JSON.stringify(this.$data.arrayEleOperation));

          // Parse visible values to display again
          for (let i = 0; i < copyarrayEleOperation.length; i += 1) {
            for (let k = 0; k < copyarrayEleOperation[i].ELEMENTSEQUENCE.length; k += 1) {
              const element = copyarrayEleOperation[i].ELEMENTSEQUENCE[k];
              // Update with DB value
              copyarrayEleOperation[i].ELEMENTSEQUENCE[k].VALOR = this.parseSerieElement(element.VALOR, true);
            }
          }

          const motorData = {
            exercise: objexercise,
            configuration: this.configuration,
            elements: copyarrayEleOperation,
            totalElements: copyarrayEleOperation.length,
          };

          let exerciseID = null;
          if (this.$props.exercise) {
            exerciseID = this.$props.exercise.ID;
          }
          if (exerciseID === null) { // Means there is no exercise created here, get tempID from storage
            const tempID = window.sessionStorage.getItem('tempEngineID');
            exerciseID = `tempID_${this.type}_${tempID}`;
          }
          console.log(`saveStorage: ${exerciseID}`);

          // Grabo los datos del motor
          window.sessionStorage.setItem(`engine_${this.type}_${exerciseID}`, JSON.stringify(motorData));

          // Cierro el modal
          this.$root.$emit('bv::hide::modal', `baseEngineModal_${this.type}`);
        });
      });
    },
    async getMotorData(id, apiCall) {
      this.loading = true;

      try {
        const response = await this.axios.get(apiCall, {
          params: {
            ejercicios_id: id,
          },
        });
        this.configuration = response.data.config;
        response.data.elements.forEach((element) => {
          const sequence = [];
          element.ELEMENTSEQUENCE.forEach((seq) => {
            sequence.push({
              ID: seq.ID,
              POSICION: seq.POSICION,
              VALOR: this.parseSerieElement(seq.VALOR, false),
              VISIBLE: seq.VISIBLE,
              INCOGNITA: seq.INCOGNITA,
            });
          });
          this.$data.arrayEleOperation.push({
            ELEMENTSEQUENCE: sequence,
            ID: element.ID,
            POSICION: element.POSICION,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el ejercicio', { type: 'warning' });
      }

      this.loading = false;
    },
  },
};
